module.exports = __webpack_public_path__ + "img/04.76d33acb.jpg";